module.exports = __webpack_public_path__ + "static/hero-image-desktop-1e68357076160913ac46eb0b9dcff0f3.png";